
export default function Footer() {
  return (
    <footer className="bg-gray-800 mt-16">
      {/* Main Footer Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {/* Company Info */}
          <div className="lg:col-span-1">
            <div className="flex items-center space-x-3 mb-4">
              <div className="w-8 h-8 bg-orange-500 rounded-lg flex items-center justify-center">
                <i className="ri-shield-check-line text-white"></i>
              </div>
              <h3 className="text-lg font-bold text-white">Home Security Advisors</h3>
            </div>
            
            {/* Rating */}
            <div className="flex items-center space-x-2 mb-4">
              <div className="flex text-yellow-400">
                <i className="ri-star-fill text-sm"></i>
                <i className="ri-star-fill text-sm"></i>
                <i className="ri-star-fill text-sm"></i>
                <i className="ri-star-fill text-sm"></i>
                <i className="ri-star-fill text-sm"></i>
              </div>
              <span className="text-sm text-gray-300">4.9/5 (2,847 reviews)</span>
            </div>
            
            <p className="text-sm text-gray-300 mb-6">
              Protecting families and homes since 2009. Your trusted partner in home security and smart home integration with 24/7 professional monitoring.
            </p>
            
            {/* Contact */}
            <div className="space-y-3">
              <button className="bg-orange-500 hover:bg-orange-600 text-white px-4 py-2 rounded-lg font-medium flex items-center space-x-2 whitespace-nowrap cursor-pointer transition-colors">
                <i className="ri-phone-line"></i>
                <span>Call Now for Instant Quote: 7027601474</span>
              </button>
              <button className="border border-gray-600 hover:border-gray-500 text-gray-300 hover:text-white px-4 py-2 rounded-lg font-medium flex items-center space-x-2 whitespace-nowrap cursor-pointer transition-colors">
                <i className="ri-mail-line text-orange-500"></i>
                <span>Email Us</span>
              </button>
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-lg font-semibold text-white mb-4">Services</h4>
            <ul className="space-y-2">
              <li className="text-gray-400 cursor-pointer hover:text-white">Security Cameras</li>
              <li className="text-gray-400 cursor-pointer hover:text-white">Alarm Systems</li>
              <li className="text-gray-400 cursor-pointer hover:text-white">Smart Home Integration</li>
              <li className="text-gray-400 cursor-pointer hover:text-white">24/7 Monitoring</li>
              <li className="text-gray-400 cursor-pointer hover:text-white">Security Audits</li>
              <li className="text-gray-400 cursor-pointer hover:text-white">Installation & Setup</li>
            </ul>
          </div>

          {/* Business Hours & Service Areas */}
          <div>
            <h4 className="text-lg font-semibold text-white mb-4">Business Hours</h4>
            <div className="space-y-2 mb-6">
              <div className="flex items-center space-x-2 text-gray-400">
                <i className="ri-calendar-line text-orange-500"></i>
                <span>Mon-Fri: 8 AM - 8 PM</span>
              </div>
              <div className="flex items-center space-x-2 text-gray-400">
                <i className="ri-calendar-line text-orange-500"></i>
                <span>Sat: 9 AM - 6 PM</span>
              </div>
              <div className="flex items-center space-x-2 text-gray-400">
                <i className="ri-calendar-line text-orange-500"></i>
                <span>Sun: Emergency Only</span>
              </div>
              <div className="flex items-center space-x-2 text-orange-400 font-semibold">
                <i className="ri-time-line text-orange-500"></i>
                <span>24/7 Monitoring</span>
              </div>
            </div>
            
            <h4 className="text-lg font-semibold text-white mb-4">Service Areas</h4>
            <p className="text-sm text-gray-400">Major metropolitan areas with high-crime zip codes</p>
          </div>
        </div>
      </div>

      {/* Certifications Section */}
      <div className="border-t border-gray-700 bg-gray-800 py-6">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-wrap justify-center items-center gap-6">
            <div className="flex items-center space-x-2">
              <div className="w-6 h-6 bg-blue-500 rounded-full flex items-center justify-center">
                <i className="ri-shield-check-line text-white text-xs"></i>
              </div>
              <span className="text-gray-300">BBB A+</span>
            </div>
            <div className="flex items-center space-x-2">
              <div className="w-6 h-6 bg-red-500 rounded-full flex items-center justify-center">
                <i className="ri-fire-line text-white text-xs"></i>
              </div>
              <span className="text-gray-300">NFPA Certified</span>
            </div>
            <div className="flex items-center space-x-2">
              <div className="w-6 h-6 bg-green-500 rounded-full flex items-center justify-center">
                <i className="ri-checkbox-circle-line text-white text-xs"></i>
              </div>
              <span className="text-gray-300">UL Listed</span>
            </div>
            <div className="flex items-center space-x-2">
              <div className="w-6 h-6 bg-purple-500 rounded-full flex items-center justify-center">
                <i className="ri-award-line text-white text-xs"></i>
              </div>
              <span className="text-gray-300">Licensed, Bonded & Insured</span>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Footer */}
      <div className="border-t border-gray-700 bg-gray-900">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-400 text-sm mb-4 md:mb-0">
              © 2025 Home Security Advisors. All rights reserved.
            </p>
            <div className="flex flex-col md:flex-row items-center space-y-2 md:space-y-0 md:space-x-6">
              <div className="flex items-center space-x-4 text-sm">
                <a href="/privacy-policy" className="text-gray-400 hover:text-gray-300 cursor-pointer">Privacy Policy</a>
                <span className="text-gray-600">•</span>
                <a href="/terms-of-service" className="text-gray-400 hover:text-gray-300 cursor-pointer">Terms of Service</a>
                <span className="text-gray-600">•</span>
                <a href="/tcpa-policy" className="text-gray-400 hover:text-gray-300 cursor-pointer">TCPA Policy</a>
              </div>
              <div className="mt-2 md:mt-0">
                <a 
                  href="https://readdy.ai/?origin=logo" 
                  className="text-sm text-gray-500 hover:text-gray-300 cursor-pointer"
                >
                  Powered by Readdy
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
